import styled from "styled-components";

export const NstpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  width: 100%;

  .top-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }

  .top-content h4 {
    font-size: 18px;
    font-weight: 500;
    color: #666;
    margin-bottom: 10px;
  }

  .top-content h1 {
    font-size: 48px;
    font-weight: 700;
    color: #cb3443;
    margin: 0;
  }

  .card {
    background-color: rgb(255, 251, 251);
    padding: 20px;
    border: 1px solid rgb(235, 222, 222);
    border-radius: 5px;
    width: 100%;
    margin-top: 50px;
  }

  .card p {
    font-size: 16px;
    color: #333;
    line-height: 1.5;
    text-transform: capitalize;
    margin: 0;
  }
`;
